declare namespace $ {

	export class $shm_textarea_code_rows extends $mol_list {
	}
	
}

//# sourceMappingURL=rows.view.tree.d.ts.map